import React from 'react';

export const goldReserveRouteConfig = [
  {
    routes: [
      {
        path: '/goldReserve',
        component: React.lazy(() => import('./GoldReserve')),
      },
    ],
  },
];
